/* global $:false */

import 'modernizr.js'

export default class Favorites {
  static init () {
    this.setupCornerIcons()
    this.setupBindings()
    if (window.Modernizr.touchevents) { this.showForTouch() }
  }

  static showForTouch () {
    $(this).find('[data-toggle-lot-favoring-link]').show()
  }

  static setupCornerIcons () {
    $(window.document).on('mouseenter', '[data-lot-cell]', function () {
      $(this).find('[data-toggle-lot-favoring-link]').show()
    })

    $(window.document).on('mouseleave', '[data-lot-cell]', function () {
      $(this).find('[data-toggle-lot-favoring-link]').hide()
    })
  }

  static setupBindings () {
    $(window.document).on('ajax:success', '[data-toggle-lot-favoring-link]', function (event) {
      const xhr = event.detail[2]
      const el = $(this)
      switch (xhr.status) {
        case 201:
          el.find('[data-toggle-lot-favoring-icon]').addClass('c-favoring-toggler__icon--active')
          el.find('[data-toggle-lot-favoring-icon]').removeClass('c-favoring-toggler__icon--neutral')
          el.attr('data-method', 'delete')
          break
        case 204:
          el.find('[data-toggle-lot-favoring-icon]').addClass('c-favoring-toggler__icon--neutral')
          el.find('[data-toggle-lot-favoring-icon]').removeClass('c-favoring-toggler__icon--active')
          el.attr('data-method', 'put')
          break
      }
    })
  }
}
